import React from 'react';
import Stepper from './components/Stepper';
import { StepperProvider } from './contexts/stepperContext';
import 'animate.css';

const ModalWrapper = function () {
  return (
    <StepperProvider>
      <Stepper />
    </StepperProvider>
  );
};

export default ModalWrapper;
